// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.view[data-v-41442773]{\n  position: absolute;\n  top: 80px;\n  left: 200px;\n  width: 83.5%;\n  height: 500px;\n}\n.el-icon--title[data-v-41442773]{\n  float: left;\n  margin-left: 20px;\n  margin-top: -21%;\n  color: lightgray;\n  font-size: 14px;\n}\n.come-info[data-v-41442773]{\n  margin-top: 15%;\n  margin-left: -5%;\n  color: lightgray;\n  opacity: 0.8;\n}\n", ""]);
// Exports
module.exports = exports;
